/*
  ruleta.js — Ruleta de premios (Grupostop)

  El navegador NO decide el premio: pide el giro al servidor (worker de
  Cloudflare vía /apps/ruleta) y se limita a parar la ruleta en la casilla que
  le digan. El código del cupón nunca llega aquí; se envía por correo después
  de dejar los datos.

  Las casillas se dibujan con lo que diga el servidor (etiquetas) y lo que
  venga de la sección (icono PNG y texto corto por casilla, en orden). Si el
  servidor dice que la casilla es "vuelve a tirar" (tipo "repetir"), no hay
  premio y se deja girar otra vez.

  En el editor del theme, o si el servidor no responde, funciona en modo
  demostración: casillas de ejemplo y premio al azar, sin llamar a nada.
*/
(function () {
  'use strict';

  var DEMO = [
    'Producto mesoestetic', 'Vale 300 €', '50 € en Estética Avanzada', 'Vuelve a tirar',
    'Microneedling 49 €', 'Sesión de láser', '¡Y muchos más premios!'
  ];
  var DEMO_REPETIR = 3;

  var TAM = 400; // lienzo del SVG; el tamaño real lo pone el CSS
  var CENTRO = TAM / 2;
  var RADIO = 186;
  var VUELTAS_MIN = 5;
  var DURACION = 5600;
  var XLINK = 'http://www.w3.org/1999/xlink';

  function sinMovimiento() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function svgEl(nombre, atributos) {
    var el = document.createElementNS('http://www.w3.org/2000/svg', nombre);
    for (var k in atributos) el.setAttribute(k, atributos[k]);
    return el;
  }

  function leerJSON(raiz, atributo, porDefecto) {
    try {
      return JSON.parse(raiz.getAttribute(atributo) || '') || porDefecto;
    } catch (e) {
      return porDefecto;
    }
  }

  // Punto del borde de la ruleta para un ángulo dado (0 = arriba).
  function punto(grados, radio) {
    var rad = ((grados - 90) * Math.PI) / 180;
    return [CENTRO + radio * Math.cos(rad), CENTRO + radio * Math.sin(rad)];
  }

  // Parte la etiqueta en dos líneas para que quepa en la casilla (texto radial).
  function lineas(texto) {
    var palabras = String(texto).split(' ');
    if (palabras.length < 2) return [texto];
    if (palabras.length === 2) return palabras;
    // "15 € de descuento" -> "15 €" + "de descuento"
    var corte = palabras[1].length <= 2 ? 2 : 1;
    return [palabras.slice(0, corte).join(' '), palabras.slice(corte).join(' ')];
  }

  // Reparte las palabras en líneas de como mucho `max` caracteres (hasta 3).
  function envolver(texto, max) {
    var palabras = String(texto).split(' ');
    var filas = [];
    var actual = '';
    for (var i = 0; i < palabras.length; i++) {
      var p = palabras[i];
      if (!actual) actual = p;
      else if ((actual + ' ' + p).length <= max) actual += ' ' + p;
      else { filas.push(actual); actual = p; }
    }
    if (actual) filas.push(actual);
    if (filas.length > 3) {
      filas = filas.slice(0, 2).concat([filas.slice(2).join(' ')]);
    }
    return filas;
  }

  function Ruleta(raiz) {
    this.raiz = raiz;
    this.base = raiz.getAttribute('data-endpoint') || '/apps/ruleta';
    this.demo = raiz.getAttribute('data-demo') === 'true';
    this.colores = (raiz.getAttribute('data-colores') || '#ffffff,#f6ede8').split(',');
    // Iconos y textos por casilla, en el orden de los bloques de la sección.
    this.bloques = leerJSON(raiz, 'data-casillas', []);
    this.opciones = leerJSON(raiz, 'data-opciones', {});
    this.svg = raiz.querySelector('[data-rl-wheel]');
    this.bulbos = raiz.querySelector('[data-rl-bulbs]');
    this.puntero = raiz.querySelector('[data-rl-pointer]');
    this.hub = raiz.querySelector('[data-rl-hub]');
    // Puede haber dos disparadores (el centro y el botón de abajo): los dos
    // llevan data-rl-spin, así que se cogen todos.
    this.botones = raiz.querySelectorAll('[data-rl-spin]');
    this.panel = raiz.querySelector('[data-rl-panel]');
    this.premioEl = raiz.querySelector('[data-rl-premio]');
    this.formulario = raiz.querySelector('[data-rl-form]');
    this.nombre = raiz.querySelector('[data-rl-nombre]');
    this.telefono = raiz.querySelector('[data-rl-telefono]');
    this.email = raiz.querySelector('[data-rl-email]');
    this.bases = raiz.querySelector('[data-rl-bases]');
    this.comunicaciones = raiz.querySelector('[data-rl-comunicaciones]');
    this.enviar = raiz.querySelector('[data-rl-submit]');
    this.aviso = raiz.querySelector('[data-rl-aviso]');
    this.entrega = raiz.querySelector('[data-rl-entrega]');
    this.intro = raiz.querySelector('[data-rl-intro]');
    this.casillaActual = null;
    // Ventana emergente (modo "ventana"): el panel vive dentro de ella.
    this.modal = raiz.querySelector('[data-rl-modal]');
    this.modalCaja = raiz.querySelector('[data-rl-modal-caja]');
    this.vistaRepetir = raiz.querySelector('[data-rl-vista="repetir"]');
    this.vistaBloqueo = raiz.querySelector('[data-rl-vista="bloqueo"]');
    this.repetirBtn = raiz.querySelector('[data-rl-repetir-btn]');
    this.cerrarFinal = raiz.querySelector('[data-rl-cerrar-final]');
    this.resumen = raiz.querySelector('[data-rl-resumen]');
    this.recoger = raiz.querySelector('[data-rl-recoger]');
    this.resumenTexto = raiz.querySelector('[data-rl-resumen-texto]');
    this.vista = null;
    this.entregado = false;
    this.premioActual = '';
    this.sacarModal();
    this.avisoGiro = raiz.querySelector('[data-rl-aviso-giro]');
    this.confeti = raiz.querySelector('[data-rl-confeti]');
    this.textos = leerJSON(raiz, 'data-textos', {});

    this.angulo = 0;
    this.girando = false;
    this.vale = null;
    this.casillas = [];

    this.arrancar();
  }

  Ruleta.prototype.arrancar = function () {
    var self = this;
    if (this.opciones.bombillas !== false) this.pintarBombillas();

    this.cargarCasillas().then(function (casillas) {
      self.casillas = casillas;
      self.pintarRuleta();
      self.pintarChuleta();
      self.raiz.classList.add('gst-rl--lista');
    });

    Array.prototype.forEach.call(this.botones, function (b) {
      b.addEventListener('click', function () { self.girar(); });
    });

    if (this.formulario) {
      this.formulario.addEventListener('submit', function (e) {
        e.preventDefault();
        self.reclamar();
      });
    }

    if (this.modal) {
      // La ventana ya cuelga de <body>: sus botones se buscan en ella.
      Array.prototype.forEach.call(this.modal.querySelectorAll('[data-rl-cerrar]'), function (b) {
        b.addEventListener('click', function () { self.cerrarModal(); });
      });
      if (this.repetirBtn) {
        this.repetirBtn.addEventListener('click', function () {
          self.cerrarModal();
          self.girar();
        });
      }
      if (this.recoger) {
        this.recoger.addEventListener('click', function () { self.abrirModal('premio'); });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.vista) self.cerrarModal();
      });
    }

    // Solo en el editor, con "Ver esta ventana en el editor" marcado.
    if (this.opciones.bloqueoPrevisualizar) {
      setTimeout(function () { self.mostrarBloqueo(null); }, 400);
    }
  };

  // ---------- Ventana emergente ----------

  /*
    La ventana se saca de la sección y se cuelga de <body>: dentro de la
    sección (overflow hidden, cabecera fija con z-index, transformaciones del
    theme) quedaba tapada o recortada. Como los colores son variables de la
    sección, se copian a la ventana antes de moverla.
  */
  var VARS_MODAL = ['--rl-card', '--rl-card-text', '--rl-prize', '--rl-border', '--rl-error', '--rl-btn', '--rl-btn-text', '--rl-modal-capa', '--rl-modal-capa-op', '--rl-glow', '--rl-text'];

  Ruleta.prototype.sacarModal = function () {
    if (!this.modal) return;
    var seccion = this.raiz.closest('[id^="shopify-section"]');
    var id = seccion ? seccion.id : 'gst-rl';
    // En el editor la sección se vuelve a pintar: fuera la ventana anterior.
    Array.prototype.forEach.call(document.body.querySelectorAll('.gst-rl__modal[data-rl-de="' + id + '"]'), function (vieja) {
      vieja.parentNode.removeChild(vieja);
    });
    var estilos = getComputedStyle(this.raiz);
    for (var i = 0; i < VARS_MODAL.length; i++) {
      var valor = estilos.getPropertyValue(VARS_MODAL[i]);
      if (valor) this.modal.style.setProperty(VARS_MODAL[i], valor.trim());
    }
    this.modal.setAttribute('data-rl-de', id);
    document.body.appendChild(this.modal);
  };

  Ruleta.prototype.abrirModal = function (vista) {
    if (!this.modal) return;
    this.vista = vista;
    if (this.vistaRepetir) this.vistaRepetir.hidden = vista !== 'repetir';
    if (this.vistaBloqueo) this.vistaBloqueo.hidden = vista !== 'bloqueo';
    if (this.panel) {
      this.panel.hidden = vista !== 'premio';
      this.panel.classList.add('gst-rl__panel--visible');
      this.panel.setAttribute('aria-hidden', vista !== 'premio' ? 'true' : 'false');
    }
    this.modal.hidden = false;
    document.documentElement.classList.add('gst-rl-modal-abierta');
    if (this.recoger) this.recoger.hidden = true;
    var foco = vista === 'premio' && !this.entregado && this.nombre ? this.nombre : this.modalCaja;
    if (foco) foco.focus({preventScroll: true});
  };

  /*
    Cerrar: con el premio sin reclamar se pide confirmación (ajuste) y queda
    bajo la ruleta el botón "Recoger mi premio" que la reabre; el vale sigue
    vivo en el servidor hasta que caduque. Con el premio ya entregado, el
    mensaje final se queda bajo la ruleta.
  */
  Ruleta.prototype.cerrarModal = function () {
    if (!this.modal || !this.vista) return;
    var vista = this.vista;
    if (vista === 'premio' && !this.entregado && this.textos.confirmarCierre) {
      if (!window.confirm(this.textos.confirmarCierre)) return;
    }
    this.modal.hidden = true;
    this.vista = null;
    document.documentElement.classList.remove('gst-rl-modal-abierta');

    if (vista !== 'premio' || !this.resumen) return;
    this.resumen.hidden = false;
    if (this.entregado) {
      if (this.resumenTexto && this.entrega) {
        this.resumenTexto.innerHTML = this.entrega.innerHTML;
        this.resumenTexto.hidden = false;
      }
    } else if (this.recoger) {
      this.recoger.textContent = String(this.textos.recoger || 'Recoger mi premio').replace('{premio}', this.premioActual);
      this.recoger.hidden = false;
      this.recoger.focus({preventScroll: true});
    }
  };

  // Casillas de demostración: si la sección ya tiene bloques, se usan esos
  // (así en el editor se ve la ruleta real); si no, las de ejemplo.
  Ruleta.prototype.casillasDemo = function () {
    if (this.bloques.length >= 2) {
      return this.bloques.map(function (b, i) {
        return {etiqueta: b.texto || 'Premio ' + (i + 1), repetir: !!b.repetir};
      });
    }
    return DEMO.map(function (t, i) { return {etiqueta: t, repetir: i === DEMO_REPETIR}; });
  };

  // Junta lo del servidor (etiqueta, tipo) con lo de la sección (icono, texto).
  Ruleta.prototype.combinar = function (lista) {
    var self = this;
    return lista.map(function (c, i) {
      var b = self.bloques[i] || {};
      return {
        etiqueta: c.etiqueta,
        tipo: c.tipo || '',
        texto: b.texto || c.etiqueta,
        icono: b.icono || '',
        color: b.color || '',
        textoTam: Number(b.textoTam) || 0,
        textoColor: b.textoColor || '',
        negrita: b.negrita || 'seccion',
        mensaje: b.mensaje || '',
        botonTexto: b.botonTexto || '',
        botonUrl: b.botonUrl || '',
        correoEnviar: b.correoEnviar !== false,
        correoAsunto: b.correoAsunto || '',
        repetir: !!c.repetir
      };
    });
  };

  // También en el editor se piden las casillas reales al servidor (así los
  // bloques se ven sobre los premios de verdad); el giro sigue siendo de
  // demostración. Si el servidor no responde, casillas de ejemplo.
  Ruleta.prototype.cargarCasillas = function () {
    var self = this;
    return fetch(this.base + '/config', {credentials: 'same-origin'})
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d.ok || !d.casillas || !d.casillas.length) throw new Error('sin casillas');
        return self.combinar(d.casillas.map(function (c) {
          return {etiqueta: c.etiqueta, tipo: c.tipo || '', repetir: c.tipo === 'repetir'};
        }));
      })
      .catch(function () {
        // Sin servidor no se puede repartir nada, pero la ruleta se ve igual.
        self.demo = true;
        return self.combinar(self.casillasDemo());
      });
  };

  // Chuleta del editor: qué premio corresponde a cada bloque "Casilla".
  Ruleta.prototype.pintarChuleta = function () {
    var lista = this.raiz.querySelector('[data-rl-chuleta-lista]');
    if (!lista) return;
    lista.innerHTML = '';
    for (var i = 0; i < this.casillas.length; i++) {
      var c = this.casillas[i];
      var li = document.createElement('li');
      li.setAttribute('data-rl-chuleta-fila', i);
      var falta = [];
      if (!this.bloques[i]) falta.push('sin bloque');
      else if (!c.icono) falta.push('sin icono');
      li.innerHTML =
        '<b>Bloque ' + (i + 1) + '</b> → ' + escapar(c.etiqueta) +
        (c.tipo ? ' <i>(' + escapar(c.tipo) + ')</i>' : '') +
        (falta.length ? ' <span class="gst-rl__chuleta-falta">' + falta.join(', ') + '</span>' : '');
      lista.appendChild(li);
    }
  };

  // Al seleccionar un bloque "Casilla" en el editor, se ilumina su casilla.
  Ruleta.prototype.marcarCasilla = function (i) {
    var marcadas = this.raiz.querySelectorAll('.gst-rl__seg--marca, .gst-rl__chuleta-fila--marca');
    Array.prototype.forEach.call(marcadas, function (el) {
      el.classList.remove('gst-rl__seg--marca', 'gst-rl__chuleta-fila--marca');
    });
    if (i == null) return;
    var seg = this.svg.querySelector('[data-casilla="' + i + '"]');
    if (seg) seg.classList.add('gst-rl__seg--marca');
    var fila = this.raiz.querySelector('[data-rl-chuleta-fila="' + i + '"]');
    if (fila) fila.classList.add('gst-rl__chuleta-fila--marca');
  };

  function escapar(t) {
    return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  Ruleta.prototype.pintarRuleta = function () {
    var n = this.casillas.length;
    var sector = 360 / n;
    var aro = this.opciones.aro == null ? 8 : Number(this.opciones.aro);
    var horizontal = this.opciones.orientacion !== 'fuera' && n <= 8;
    this.svg.innerHTML = '';
    this.etiquetas = [];

    if (aro > 0) {
      this.svg.appendChild(svgEl('circle', {cx: CENTRO, cy: CENTRO, r: RADIO + aro, fill: 'var(--rl-ring)'}));
    }

    for (var i = 0; i < n; i++) {
      var desde = i * sector;
      var hasta = desde + sector;
      var a = punto(desde, RADIO);
      var b = punto(hasta, RADIO);
      var arco = sector > 180 ? 1 : 0;

      var casilla = svgEl('path', {
        d: 'M' + CENTRO + ',' + CENTRO + ' L' + a[0] + ',' + a[1] +
           ' A' + RADIO + ',' + RADIO + ' 0 ' + arco + ' 1 ' + b[0] + ',' + b[1] + ' Z',
        // Color propio de la casilla (bloque) o la alternancia de la sección.
        fill: this.casillas[i].color || this.colores[i % this.colores.length],
        stroke: 'var(--rl-sep)',
        'stroke-width': 2,
        class: 'gst-rl__seg'
      });
      casilla.setAttribute('data-casilla', i);
      this.svg.appendChild(casilla);

      var medio = desde + sector / 2;
      var grupo;
      if (horizontal) {
        // Icono y texto en horizontal, siempre legibles: el grupo no se gira
        // con la casilla y, durante el giro, se le aplica la rotación
        // contraria a la de la rueda (ver orientar()).
        grupo = svgEl('g', {class: 'gst-rl__label'});
        this.pintarHorizontal(grupo, this.casillas[i], medio, sector);
        this.etiquetas.push(grupo);
      } else {
        grupo = svgEl('g', {transform: 'rotate(' + medio + ' ' + CENTRO + ' ' + CENTRO + ')'});
        // Con pocas casillas (hasta 8) cabe el icono arriba y el texto debajo,
        // los dos mirando hacia fuera como en una ruleta de feria. Con más,
        // el texto va en dirección radial, que es lo único que cabe.
        if (n <= 8) this.pintarApilado(grupo, this.casillas[i], sector);
        else this.pintarRadial(grupo, this.casillas[i].texto, n, medio);
      }
      this.svg.appendChild(grupo);
    }

    this.svg.appendChild(svgEl('circle', {cx: CENTRO, cy: CENTRO, r: 26, fill: 'var(--rl-sep)'}));
  };

  // Tamaño, color y peso del texto de una casilla: lo suyo o lo de la sección.
  Ruleta.prototype.estiloTexto = function (casilla) {
    var negritaSeccion = this.opciones.negrita !== false;
    var negrita = casilla.negrita === 'si' ? true : casilla.negrita === 'no' ? false : negritaSeccion;
    return {
      tam: casilla.textoTam > 0 ? casilla.textoTam : Number(this.opciones.textoTam) || 13,
      color: casilla.textoColor || 'var(--rl-seg-text)',
      peso: negrita ? 700 : 400
    };
  };

  /*
    Icono cerca del borde y el texto debajo, en horizontal respecto a la
    casilla (el grupo ya está girado para que la casilla "mire" hacia arriba).
    El ancho disponible a cada radio es la cuerda de la casilla: el texto se
    parte en líneas que quepan y, si una palabra sola no cabe, se encoge.
  */
  Ruleta.prototype.pintarApilado = function (grupo, casilla, sector) {
    var tamIcono = Number(this.opciones.iconoTam) || 42;
    var estilo = this.estiloTexto(casilla);
    var tamTexto = estilo.tam;
    var mitad = (sector / 2) * Math.PI / 180;
    var conIcono = !!casilla.icono;

    if (conIcono) {
      var rIcono = RADIO * 0.74;
      var img = svgEl('image', {
        x: CENTRO - tamIcono / 2,
        y: CENTRO - rIcono - tamIcono / 2,
        width: tamIcono,
        height: tamIcono,
        preserveAspectRatio: 'xMidYMid meet',
        href: casilla.icono
      });
      img.setAttributeNS(XLINK, 'xlink:href', casilla.icono);
      grupo.appendChild(img);
    }

    var rTexto = conIcono ? RADIO * 0.5 : RADIO * 0.6;
    var anchoCar = tamTexto * 0.56;
    var cuerda = 2 * rTexto * Math.sin(mitad) * 0.95;
    var maxCar = Math.max(4, Math.floor(cuerda / anchoCar));
    var filas = envolver(casilla.texto, maxCar);
    var alto = tamTexto * 1.15;

    for (var f = 0; f < filas.length; f++) {
      var y = CENTRO - rTexto + (f - (filas.length - 1) / 2) * alto;
      // La cuerda real a la altura de esta línea (más estrecha cuanto más cerca del centro).
      var cuerdaFila = 2 * (CENTRO - y) * Math.sin(mitad) * 0.95;
      var tam = Math.min(tamTexto, cuerdaFila / (filas[f].length * 0.56));
      var texto = svgEl('text', {
        x: CENTRO,
        y: y,
        fill: estilo.color,
        'font-size': Math.max(7, tam).toFixed(1),
        'font-weight': estilo.peso,
        'text-anchor': 'middle',
        'dominant-baseline': 'middle'
      });
      texto.textContent = filas[f];
      grupo.appendChild(texto);
    }
  };

  /*
    Icono encima y texto debajo, los dos en horizontal, centrados en el punto
    medio de la casilla. El ancho útil se estima con la cuerda de la casilla a
    la distancia de cada línea (lo que cabe en las casillas de arriba y abajo;
    en las de los lados sobra sitio). El grupo guarda su centro como origen de
    giro para poder contrarrestar la rotación de la rueda.
  */
  Ruleta.prototype.pintarHorizontal = function (grupo, casilla, medio, sector) {
    var tamIcono = Number(this.opciones.iconoTam) || 42;
    var estilo = this.estiloTexto(casilla);
    var tamTexto = estilo.tam;
    var mitad = (sector / 2) * Math.PI / 180;
    var conIcono = !!casilla.icono;
    var c = punto(medio, RADIO * 0.6);
    var cx = c[0];
    var cy = c[1];

    var cuerda = 2 * RADIO * 0.6 * Math.sin(mitad) * 0.92;
    var maxCar = Math.max(4, Math.floor(cuerda / (tamTexto * 0.56)));
    var filas = envolver(casilla.texto, maxCar);
    var alto = tamTexto * 1.15;
    var cabecera = conIcono ? tamIcono + 4 : 0;
    var top = cy - (cabecera + filas.length * alto) / 2;

    if (conIcono) {
      var img = svgEl('image', {
        x: cx - tamIcono / 2,
        y: top,
        width: tamIcono,
        height: tamIcono,
        preserveAspectRatio: 'xMidYMid meet',
        href: casilla.icono
      });
      img.setAttributeNS(XLINK, 'xlink:href', casilla.icono);
      grupo.appendChild(img);
    }

    for (var f = 0; f < filas.length; f++) {
      var y = top + cabecera + alto * (f + 0.5);
      var rFila = Math.sqrt((cx - CENTRO) * (cx - CENTRO) + (y - CENTRO) * (y - CENTRO));
      var cuerdaFila = 2 * rFila * Math.sin(mitad) * 0.92;
      var tam = Math.min(tamTexto, cuerdaFila / (filas[f].length * 0.56));
      var texto = svgEl('text', {
        x: cx,
        y: y,
        fill: estilo.color,
        'font-size': Math.max(7, tam).toFixed(1),
        'font-weight': estilo.peso,
        'text-anchor': 'middle',
        'dominant-baseline': 'middle'
      });
      texto.textContent = filas[f];
      grupo.appendChild(texto);
    }

    grupo.style.transformOrigin = cx + 'px ' + cy + 'px';
  };

  // Las etiquetas horizontales giran lo contrario que la rueda, con la misma
  // curva y duración, y así siguen derechas mientras gira y al parar.
  Ruleta.prototype.orientar = function (destino, animado) {
    if (!this.etiquetas) return;
    for (var i = 0; i < this.etiquetas.length; i++) {
      var g = this.etiquetas[i];
      g.style.transition = animado ? 'transform ' + DURACION + 'ms cubic-bezier(0.16, 0.85, 0.12, 1)' : 'none';
      g.style.transform = 'rotate(' + -destino + 'deg)';
    }
  };

  // Texto en dirección radial (se lee del borde hacia el centro). Las líneas
  // se separan PERPENDICULARMENTE al radio: si se separasen a lo largo del
  // radio se montarían una encima de otra.
  Ruleta.prototype.pintarRadial = function (grupo, etiqueta, n, medio) {
    var filas = lineas(etiqueta);
    var radioTexto = RADIO - 74;
    var alto = n > 12 ? 13 : 16;
    // En la mitad izquierda el texto saldría boca abajo: se gira al revés y
    // se invierte la separación de las líneas para que sigan en orden.
    var invertido = medio > 180;
    var giro = invertido ? -90 : 90;
    var signo = invertido ? 1 : -1;
    for (var f = 0; f < filas.length; f++) {
      var x = CENTRO + signo * (f - (filas.length - 1) / 2) * alto;
      var y = CENTRO - radioTexto;
      var texto = svgEl('text', {
        x: x,
        y: y,
        fill: 'var(--rl-seg-text)',
        'font-size': filas[f].length > 11 ? 13 : 15,
        'font-weight': 700,
        'text-anchor': 'middle',
        'dominant-baseline': 'middle',
        transform: 'rotate(' + giro + ' ' + x + ' ' + y + ')'
      });
      texto.textContent = filas[f];
      grupo.appendChild(texto);
    }
  };

  Ruleta.prototype.pintarBombillas = function () {
    if (!this.bulbos) return;
    var total = 24;
    var aro = this.opciones.aro == null ? 8 : Number(this.opciones.aro);
    this.bulbos.innerHTML = '';
    for (var i = 0; i < total; i++) {
      var p = punto((360 / total) * i, RADIO + Math.max(aro, 5));
      var b = svgEl('circle', {cx: p[0], cy: p[1], r: 5, class: 'gst-rl__bulb'});
      this.bulbos.appendChild(b);
    }
    this.animarBombillas();
  };

  // Luces en carrusel: dos encendidas de cada tres, girando.
  Ruleta.prototype.animarBombillas = function () {
    if (sinMovimiento()) return;
    var luces = this.bulbos.querySelectorAll('circle');
    var paso = 0;
    setInterval(function () {
      for (var i = 0; i < luces.length; i++) {
        luces[i].classList.toggle('gst-rl__bulb--on', (i + paso) % 3 !== 0);
      }
      paso++;
    }, 420);
  };

  /*
    Un giro por navegador: al salir un premio de verdad se deja una marca en
    localStorage con la casilla. Si vuelve a pulsar Girar, no se gira: sale
    la vista "ya has jugado" con el tratamiento recomendado. El servidor
    hace de respaldo con su límite por IP (código `limite-ip`).
  */
  var CLAVE_JUGADO = 'gst_ruleta_jugado';

  Ruleta.prototype.marcaJugado = function () {
    try {
      var v = window.localStorage.getItem(CLAVE_JUGADO);
      return v ? JSON.parse(v) : null;
    } catch (e) {
      return null;
    }
  };

  Ruleta.prototype.marcarJugado = function (casilla) {
    try {
      window.localStorage.setItem(CLAVE_JUGADO, JSON.stringify({casilla: casilla, fecha: Date.now()}));
    } catch (e) {
      // almacenamiento bloqueado: queda el límite del servidor
    }
  };

  // Enseña la vista "ya has jugado" con la tarjeta de la casilla (si la
  // tiene) o la general. En modo ventana se abre la ventana; en modo
  // "debajo" se muestra en el sitio del panel.
  Ruleta.prototype.mostrarBloqueo = function (casilla) {
    if (!this.vistaBloqueo) return false;
    var tarjetas = this.vistaBloqueo.querySelectorAll('[data-rl-producto]');
    var elegida = null;
    Array.prototype.forEach.call(tarjetas, function (t) {
      t.hidden = true;
      var clave = t.getAttribute('data-rl-producto');
      if (casilla != null && String(casilla) === clave) elegida = t;
    });
    if (!elegida) elegida = this.vistaBloqueo.querySelector('[data-rl-producto="general"]');
    if (elegida) elegida.hidden = false;

    if (this.modal) {
      this.abrirModal('bloqueo');
    } else {
      this.vistaBloqueo.hidden = false;
      this.vistaBloqueo.scrollIntoView({behavior: sinMovimiento() ? 'auto' : 'smooth', block: 'center'});
    }
    return true;
  };

  Ruleta.prototype.girar = function () {
    if (this.girando || !this.casillas.length) return;
    var self = this;

    if (!this.demo && this.opciones.bloqueo && this.vistaBloqueo) {
      var marca = this.marcaJugado();
      if (marca) return this.mostrarBloqueo(marca.casilla);
    }
    this.girando = true;
    this.bloquear(true);
    this.decirGiro('');

    this.pedirGiro()
      .then(function (giro) {
        self.vale = giro.vale || null;
        self.animar(giro.casilla, giro.etiqueta, giro.tipo);
      })
      .catch(function (e) {
        self.girando = false;
        self.bloquear(false);
        // Tope del servidor por IP: misma ventana que "ya has jugado".
        if (e.codigo === 'limite-ip' && self.opciones.bloqueo && self.mostrarBloqueo(null)) return;
        self.decirGiro(e.message || self.textos.error, true);
      });
  };

  Ruleta.prototype.pedirGiro = function () {
    var self = this;
    if (this.demo) {
      var i = Math.floor(Math.random() * this.casillas.length);
      var c = this.casillas[i];
      return Promise.resolve({casilla: i, etiqueta: c.etiqueta, tipo: c.repetir ? 'repetir' : 'premio'});
    }
    return fetch(this.base + '/girar', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json'},
      body: '{}'
    }).then(function (r) {
      return r.json().catch(function () { throw new Error(self.textos.error); });
    }).then(function (d) {
      if (!d.ok) {
        var err = new Error(d.mensaje || self.textos.error);
        err.codigo = d.codigo || '';
        throw err;
      }
      return d;
    });
  };

  Ruleta.prototype.animar = function (casilla, etiqueta, tipo) {
    var self = this;
    var sector = 360 / this.casillas.length;
    var centro = casilla * sector + sector / 2;

    // Vueltas completas + lo que falte para dejar esa casilla bajo el puntero,
    // con un pequeño desvío dentro de la casilla para que no pare siempre igual.
    var desvio = (Math.random() - 0.5) * (sector * 0.5);
    var vueltas = VUELTAS_MIN + Math.floor(Math.random() * 3);
    var destino = this.angulo + vueltas * 360 + ((360 - ((this.angulo + centro + desvio) % 360)) % 360);

    if (sinMovimiento()) {
      this.angulo = destino;
      this.svg.style.transform = 'rotate(' + destino + 'deg)';
      this.orientar(destino, false);
      this.terminar(casilla, etiqueta, tipo);
      return;
    }

    this.svg.style.transition = 'transform ' + DURACION + 'ms cubic-bezier(0.16, 0.85, 0.12, 1)';
    this.svg.style.transform = 'rotate(' + destino + 'deg)';
    this.orientar(destino, true);
    this.angulo = destino;
    this.tictac(destino);

    setTimeout(function () { self.terminar(casilla, etiqueta, tipo); }, DURACION + 80);
  };

  // El puntero da un tirón cada vez que pasa una casilla: es lo que hace que
  // la ruleta "suene" aunque no haya sonido.
  Ruleta.prototype.tictac = function (destino) {
    var self = this;
    var sector = 360 / this.casillas.length;
    var inicio = performance.now();
    var desde = destino - (destino - (this.anguloPrevio || 0));
    var recorrido = destino - (this.anguloPrevio || 0);
    this.anguloPrevio = destino;
    var ultima = -1;

    function paso(ahora) {
      var t = Math.min(1, (ahora - inicio) / DURACION);
      // Misma curva que el CSS, aproximada, para que el tic vaya a compás.
      var avance = 1 - Math.pow(1 - t, 3.2);
      var actual = desde + recorrido * avance;
      var cual = Math.floor(actual / sector);
      if (cual !== ultima) {
        ultima = cual;
        self.puntero.classList.remove('gst-rl__pointer--tic');
        void self.puntero.offsetWidth;
        self.puntero.classList.add('gst-rl__pointer--tic');
      }
      if (t < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  };

  Ruleta.prototype.terminar = function (casilla, etiqueta, tipo) {
    this.girando = false;
    var anterior = this.svg.querySelector('.gst-rl__seg--gana');
    if (anterior) anterior.classList.remove('gst-rl__seg--gana');
    var seg = this.svg.querySelector('[data-casilla="' + casilla + '"]');
    if (seg) seg.classList.add('gst-rl__seg--gana');

    // "Vuelve a tirar": sin premio, sin formulario, y la ruleta vuelve a
    // estar lista. El límite de giros lo lleva el servidor.
    if (tipo === 'repetir') {
      this.vale = null;
      this.bloquear(false);
      this.decirGiro(this.textos.repetir || etiqueta);
      if (this.modal && this.opciones.repetirVentana !== false) this.abrirModal('repetir');
      return;
    }

    this.lanzarConfeti();
    this.casillaActual = casilla;
    this.premioActual = etiqueta;
    // Premio de verdad: este navegador ya ha jugado.
    if (!this.demo && this.opciones.bloqueo) this.marcarJugado(casilla);

    if (this.premioEl) this.premioEl.textContent = etiqueta;
    if (this.demo) this.decir(this.textos.demo || '');
    if (this.modal) {
      // Un respiro para ver el confeti antes de que salga la ventana.
      var self = this;
      setTimeout(function () { self.abrirModal('premio'); }, sinMovimiento() ? 0 : 900);
      return;
    }
    if (this.panel) {
      this.panel.classList.add('gst-rl__panel--visible');
      this.panel.setAttribute('aria-hidden', 'false');
    }
    if (this.nombre) this.nombre.focus({preventScroll: true});
  };

  // Mismas reglas que el servidor, que es quien valida de verdad: aquí solo
  // se evita un viaje para avisar de lo evidente.
  function telefonoValido(valor) {
    var t = String(valor || '').replace(/[\s\-.()]/g, '');
    if (t.indexOf('00') === 0) t = '+' + t.slice(2);
    return /^[6789]\d{8}$/.test(t) || /^34[6789]\d{8}$/.test(t) || /^\+\d{9,15}$/.test(t);
  }

  function nombreValido(valor) {
    return (String(valor || '').match(/[A-Za-zÀ-ÿ]/g) || []).length >= 2;
  }

  // Marca el campo que falla y lleva el foco a él.
  Ruleta.prototype.fallo = function (campo, mensaje) {
    var marcados = this.formulario.querySelectorAll('.gst-rl__field--error, .gst-rl__consent--error');
    Array.prototype.forEach.call(marcados, function (el) {
      el.classList.remove('gst-rl__field--error', 'gst-rl__consent--error');
    });
    if (campo) {
      var caja = campo.closest('.gst-rl__field') || campo.closest('.gst-rl__consent');
      if (caja) caja.classList.add(caja.classList.contains('gst-rl__consent') ? 'gst-rl__consent--error' : 'gst-rl__field--error');
      campo.focus({preventScroll: false});
    }
    this.decir(mensaje, true);
  };

  Ruleta.prototype.reclamar = function () {
    var self = this;
    var nombre = (this.nombre.value || '').replace(/\s+/g, ' ').trim();
    var telefono = (this.telefono.value || '').trim();
    var email = (this.email.value || '').trim();
    var comunicaciones = !!(this.comunicaciones && this.comunicaciones.checked);
    var comunicacionesObligatoria = !!this.comunicaciones && this.comunicaciones.getAttribute('data-obligatoria') === 'true';

    if (!nombreValido(nombre)) return this.fallo(this.nombre, this.textos.nombreInvalido);
    if (!telefonoValido(telefono)) return this.fallo(this.telefono, this.textos.telefonoInvalido);
    if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email)) return this.fallo(this.email, this.textos.emailInvalido);
    if (!this.bases.checked) return this.fallo(this.bases, this.textos.sinBases);
    if (comunicacionesObligatoria && !comunicaciones) return this.fallo(this.comunicaciones, this.textos.sinComunicaciones);
    this.fallo(null, '');

    if (this.demo) {
      this.entregar({casilla: this.casillaActual, email: email, nombre: nombre});
      return this.decir(this.textos.demoEnviado || '');
    }

    // Mientras se envía, el propio botón lo dice (con su spinner).
    this.enviar.disabled = true;
    this.enviar.classList.add('gst-rl__submit--enviando');
    this.enviar.setAttribute('data-texto', this.enviar.textContent);
    this.enviar.textContent = this.textos.enviando || 'Enviando…';
    this.decir('');

    // El correo al ganador lleva el mismo mensaje y botón que verá en
    // pantalla (bloque Casilla del editor). El servidor lo limpia, rellena
    // {nombre}/{email} y lo mete en su plantilla; si la casilla no tiene
    // mensaje propio usa el suyo o, en último caso, el mensaje general.
    var c = this.casillas[this.casillaActual] || {};
    var correo = {
      enviar: c.correoEnviar !== false,
      asunto: c.correoAsunto || '',
      mensaje: c.mensaje || '',
      mensajeGeneral: this.textos.exito || '',
      botonTexto: c.botonTexto || '',
      botonUrl: c.botonUrl || ''
    };

    fetch(this.base + '/premio', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        vale: this.vale,
        nombre: nombre,
        telefono: telefono,
        email: email,
        bases: true,
        comunicaciones: comunicaciones,
        correo: correo
      })
    })
      .then(function (r) { return r.json().catch(function () { throw new Error(self.textos.error); }); })
      .then(function (d) {
        if (!d.ok) throw new Error(d.mensaje || self.textos.error);
        self.decir('');
        self.entregar({casilla: d.casilla != null ? d.casilla : self.casillaActual, email: email, nombre: nombre});
      })
      .catch(function (e) {
        self.enviar.disabled = false;
        self.enviar.classList.remove('gst-rl__submit--enviando');
        self.enviar.textContent = self.enviar.getAttribute('data-texto') || self.enviar.textContent;
        self.decir(e.message || self.textos.error, true);
      });
  };

  // Premio entregado: se esconde el formulario y se enseña el mensaje de esa
  // casilla (bloque de la sección) con su botón, o el mensaje general.
  Ruleta.prototype.entregar = function (datos) {
    var c = this.casillas[datos.casilla] || {};
    var rellenar = function (t) {
      return String(t || '').replace(/\{email\}/g, datos.email || '').replace(/\{nombre\}/g, datos.nombre || '');
    };
    this.formulario.style.display = 'none';
    // Ya ha dejado sus datos: fuera la frase de "déjanos tus datos".
    if (this.intro) this.intro.hidden = true;
    this.decir('');
    this.entregado = true;
    if (this.cerrarFinal) this.cerrarFinal.hidden = false;
    if (!this.entrega) return this.decir(rellenar(this.textos.exito));

    this.entrega.innerHTML = '';
    if (c.mensaje) {
      var caja = document.createElement('div');
      caja.className = 'gst-rl__entrega-texto';
      // Viene del editor del theme (texto enriquecido), no del usuario.
      caja.innerHTML = rellenar(c.mensaje);
      this.entrega.appendChild(caja);
    } else {
      var p = document.createElement('p');
      p.className = 'gst-rl__entrega-texto';
      p.textContent = rellenar(this.textos.exito);
      this.entrega.appendChild(p);
    }
    if (c.botonTexto && c.botonUrl) {
      var a = document.createElement('a');
      a.className = 'gst-rl__entrega-boton';
      a.href = c.botonUrl;
      a.textContent = c.botonTexto;
      this.entrega.appendChild(a);
    }
    this.entrega.hidden = false;
  };

  Ruleta.prototype.bloquear = function (si) {
    Array.prototype.forEach.call(this.botones, function (b) { b.disabled = si; });
    this.raiz.classList.toggle('gst-rl--lista', !si);
  };

  // Mensajes del formulario (dentro de la tarjeta del premio).
  Ruleta.prototype.decir = function (mensaje, esError) {
    if (!this.aviso) return;
    this.aviso.textContent = mensaje || '';
    this.aviso.classList.toggle('gst-rl__aviso--error', !!esError);
  };

  // Mensajes del giro (bajo el botón): límite diario, "vuelve a tirar"…
  Ruleta.prototype.decirGiro = function (mensaje, esError) {
    if (!this.avisoGiro) return this.decir(mensaje, esError);
    this.avisoGiro.textContent = mensaje || '';
    this.avisoGiro.classList.toggle('gst-rl__aviso--error', !!esError);
  };

  // Confeti propio: unas decenas de partículas durante segundo y medio. Sin
  // librerías, que esta página ya carga bastante.
  Ruleta.prototype.lanzarConfeti = function () {
    if (!this.confeti || sinMovimiento()) return;
    var lienzo = this.confeti;
    var ctx = lienzo.getContext('2d');
    var ancho = (lienzo.width = lienzo.offsetWidth);
    var alto = (lienzo.height = lienzo.offsetHeight);
    var colores = this.colores.concat(['#ffd166', '#ed6d69', '#2b2b2b']);
    var trozos = [];

    for (var i = 0; i < 90; i++) {
      trozos.push({
        x: ancho / 2,
        y: alto / 2,
        vx: (Math.random() - 0.5) * 11,
        vy: Math.random() * -9 - 2,
        giro: Math.random() * 360,
        vgiro: (Math.random() - 0.5) * 18,
        lado: 4 + Math.random() * 6,
        color: colores[Math.floor(Math.random() * colores.length)]
      });
    }

    var inicio = performance.now();
    function pintar(ahora) {
      var t = ahora - inicio;
      ctx.clearRect(0, 0, ancho, alto);
      for (var i = 0; i < trozos.length; i++) {
        var p = trozos[i];
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.32;
        p.giro += p.vgiro;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate((p.giro * Math.PI) / 180);
        ctx.globalAlpha = Math.max(0, 1 - t / 1600);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.lado / 2, -p.lado / 2, p.lado, p.lado * 0.6);
        ctx.restore();
      }
      if (t < 1600) requestAnimationFrame(pintar);
      else ctx.clearRect(0, 0, ancho, alto);
    }
    requestAnimationFrame(pintar);
  };

  function iniciar(contexto) {
    (contexto || document).querySelectorAll('[data-gst-ruleta]').forEach(function (raiz) {
      if (raiz.dataset.rlLista === '1') return;
      raiz.dataset.rlLista = '1';
      raiz.gstRuleta = new Ruleta(raiz);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(); });
  } else {
    iniciar();
  }

  // El editor del theme vuelve a pintar la sección al cambiar un ajuste.
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });

  // Editor: seleccionar / soltar un bloque "Casilla" ilumina su casilla.
  function bloqueSeleccionado(e, marcar) {
    var ancla = e.target && e.target.closest && e.target.closest('[data-rl-bloque]');
    if (!ancla) return;
    var raiz = ancla.closest('[data-gst-ruleta]');
    if (!raiz || !raiz.gstRuleta) return;
    raiz.gstRuleta.marcarCasilla(marcar ? Number(ancla.getAttribute('data-rl-bloque')) : null);
  }
  document.addEventListener('shopify:block:select', function (e) { bloqueSeleccionado(e, true); });
  document.addEventListener('shopify:block:deselect', function (e) { bloqueSeleccionado(e, false); });
})();
